import React, { VFC, ReactNode } from "react";

import Header from "components/header/header";
import BreadCrumbs from "components/breadcrumbs";

import { BreadCrumbsData } from "lib/type";

type LayoutProps = {
  children: ReactNode;
  lists?: BreadCrumbsData[];
};

const Layout: VFC<LayoutProps> = ({ children, lists }) => {
  return (
    <div className="bg-light text-dark dark:bg-dark dark:text-light flex min-h-screen flex-col">
      <Header />
      <BreadCrumbs lists={lists} />
      <main className="relative flex-1 py-4 lg:container lg:p-8">
        {children}
      </main>
    </div>
  );
};

export default Layout;
